import { render, staticRenderFns } from "./BorderWaves.vue?vue&type=template&id=8f7d17e6&scoped=true&"
var script = {}
import style0 from "./BorderWaves.vue?vue&type=style&index=0&id=8f7d17e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f7d17e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
